var i = Object.defineProperty;
var d = (s, l, e) => l in s ? i(s, l, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[l] = e;
var a = (s, l, e) => (d(s, typeof l != "symbol" ? l + "" : l, e), e);
class c {
  /**
   * @constructor
   * @param {string} name 选项名称
   * @param {string | number} val 选项值
   * @param {boolean} [disabled=false] 是否禁用
   */
  constructor(l = "", e = l, t = !1) {
    /**
     * 选项文本
     * @type {string}
     */
    a(this, "label");
    /**
     * 选项值
     * @type {string|number}
     */
    a(this, "value");
    /**
     * 是否禁用
     * @type {boolean}
     */
    a(this, "disabled");
    this.label = l, this.value = e, this.disabled = t;
  }
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/selectOption.js
// module id = 1249
// module chunks = 67